// extracted by mini-css-extract-plugin
module.exports = {"container":"NextTime_container__2zszO","blockLabel":"NextTime_blockLabel__1e9-5","blockData":"NextTime_blockData__1jvqx"};